/* eslint-disable sort-keys-fix/sort-keys-fix */
// eslint-disable sort-keys sort-keys-fix/sort-keys-fix

const screen = {
  '2xl': '1220px',
  lg: '1024px',
  md: '768px',
  sm: '640px',
  xl: '1220px',
};

const space = {
  '0': '0px',
  '0.5': '2px',
  '1': '4px',
  '1.5': '6px',
  '1/12': '8.333333%',
  '1/2': '50%',
  '1/3': '33.333333%',
  '1/4': '25%',
  '1/5': '20%',
  '1/6': '16.666667%',
  '10': '40px',
  '10/12': '83.333333%',
  '11': '44px',
  '11/12': '91.666667%',
  '12': '48px',
  '14': '56px',
  '16': '64px',
  '2': '8px',
  '2.5': '10px',
  '2/12': '16.666667%',
  '2/3': '66.666667%',
  '2/4': '50%',
  '2/5': '40%',
  '2/6': '33.333333%',
  '20': '80px',
  '24': '96px',
  '28': '112px',
  '3': '12px',
  '3.5': '14px',
  '3/12': '25%',
  '3/4': '75%',
  '3/5': '60%',
  '3/6': '50%',
  '32': '128px',
  '36': '144px',
  '4': '16px',
  '4/12': '33.333333%',
  '4/5': '80%',
  '4/6': '66.666667%',
  '40': '160px',
  '44': '176px',
  '48': '192px',
  '5': '20px',
  '5/12': '41.666667%',
  '5/6': '83.333333%',
  '52': '208px',
  '56': '224px',
  '6': '24px',
  '6/12': '50%',
  '60': '240px',
  '64': '256px',
  '7': '28px',
  '7/12': '58.333333%',
  '72': '288px',
  '8': '32px',
  '8/12': '66.666667%',
  '80': '320px',
  '9': '36px',
  '9/12': '75%',
  '96': '384px',
  full: '100%',
  inherit: 'inherit',
  initial: 'initial',
  px: '1px',
  screen2xl: screen['2xl'],
  screenLG: screen.lg,
  screenMD: screen.md,

  screenSM: screen.sm,
  screenXL: screen.xl,
};

const spaceWithAuto = {
  ...space,
  auto: 'auto',
};

const spaceWithNone = {
  ...space,
  none: 'none',
};

const fontSize = {
  '2xl': '24px',
  '3xl': '30px',
  '4xl': '36px',
  '5xl': '48px',
  '6xl': '64px',
  base: '14px',
  inherit: 'inherit',
  initial: 'initial',
  'xl-plus': '19.2px',
  xl: '18px',
  lg: '16px',
  md: '14px',
  sm: '12px',
  xs: '10px',
};

const colorPalette = {
  black: '#000000',

  blue50: '#ebf5ff',
  blue100: '#e1effe',
  blue200: '#c3ddfd',
  blue300: '#a4cafe',
  blue400: '#76a9fa',
  blue500: '#3f83f8',
  blue600: '#1c64f2',
  blue700: '#1a56db',
  blue800: '#1e429f',
  blue900: '#233876',
  blue1000: '#0052cc',

  current: 'currentColor',

  gray50: '#F2F8FF',
  gray100: '#E1EBFA',
  gray200: '#CEDDF2',
  gray300: '#B8CBE6',
  gray350: '#b3b3b3',
  gray400: '#99AECC',
  gray500: '#5B7292',
  gray600: '#395173',
  gray700: '#192940',
  gray800: '#17253A',
  gray900: '#142133',
  green100: '#def7ec',
  green200: '#bcf0da',

  green50: '#f3faf7',
  green300: '#84e1bc',
  green400: '#31c48d',
  green500: '#0e9f6e',
  green600: '#057a55',
  green700: '#046c4e',
  green800: '#03543f',
  green900: '#014737',

  indigo100: '#e5edff',
  indigo200: '#cddbfe',
  indigo300: '#b4c6fc',
  indigo400: '#8da2fb',
  indigo50: '#f0f5ff',
  indigo500: '#6875f5',
  indigo600: '#5850ec',
  indigo700: '#5145cd',
  indigo800: '#42389d',
  indigo900: '#362f78',

  inherit: 'inherit',
  initial: 'initial',

  neutral50: '#F9FCFF',
  neutral100: '#F2F8FF',
  neutral200: '#E1EBFA',
  neutral300: '#CEDDF2',
  neutral400: '#B8CBE6',
  neutral500: '#99AECC',
  neutral600: '#5B7292',
  neutral700: '#395173',
  neutral800: '#192940',
  neutral900: '#17253A',

  orange50: '#fff8f1',
  orange100: '#feecdc',
  orange200: '#fcd9bd',
  orange300: '#fdba8c',
  orange400: '#ff8a4c',
  orange500: '#ff5a1f',
  orange600: '#d03801',
  orange700: '#b43403',
  orange800: '#8a2c0d',
  orange900: '#73230d',

  pink50: '#fdf2f8',
  pink100: '#fce8f3',
  pink200: '#fad1e8',
  pink300: '#f8b4d9',
  pink400: '#f17eb8',
  pink500: '#e74694',
  pink600: '#d61f69',
  pink700: '#bf125d',
  pink800: '#99154b',
  pink900: '#751a3d',

  purple50: '#f6f5ff',
  purple100: '#edebfe',
  purple200: '#dcd7fe',
  purple300: '#cabffd',
  purple400: '#ac94fa',
  purple500: '#9061f9',
  purple600: '#7e3af2',
  purple700: '#6c2bd9',
  purple800: '#5521b5',
  purple900: '#4a1d96',

  red50: '#fdf2f2',
  red100: '#fde8e8',
  red200: '#fbd5d5',
  red300: '#f8b4b4',
  red400: '#f98080',
  red500: '#f05252',
  red600: '#e02424',
  red700: '#c81e1e',
  red800: '#9b1c1c',
  red900: '#771d1d',

  teal50: '#edfafa',
  teal100: '#d5f5f6',
  teal200: '#afecef',
  teal300: '#7edce2',
  teal400: '#16bdca',
  teal500: '#0694a2',
  teal600: '#047481',
  teal700: '#036672',
  teal800: '#05505c',
  teal900: '#014451',

  transparent: 'transparent',

  yellow50: '#fdfdea',
  yellow100: '#fdf6b2',
  yellow200: '#fce96a',
  yellow300: '#faca15',
  yellow400: '#e3a008',
  yellow500: '#c27803',
  yellow600: '#9f580a',
  yellow700: '#8e4b10',
  yellow800: '#723b13',
  yellow900: '#633112',

  white: '#ffffff',

  bzWhite: '#FFFFFF',
  bzBlack: '#212731',
  bzBlackNormal: '#d9d9d9',
  bzBlackDarkest: '#000000',
  bzGreyDarker: '#28313C',
  bzGreyDark: '#373f49',
  bzGrey: '#818b97',
  bzGreyLight: '#C5CEDA',
  bzGreyLighter: '#D4DBE7',
  bzGreyLightest: '#EFF1F6',
  bzGreyNormal: '#4d5866',
  bzGreen: '#30BFA3',
  bzGreenLight: '#18be39',
  bzRed: '#E5594E',
  bzYellow: '#FFD373',
  bzBlue: '#008FD9',
  bzOrange: '#E3A542',
  bzOrangeLight: '#ff9c29',
  bzOrangeNormal: '#373f49',
  bzIndiaBlue: '#24344F',

  bzBlueDark: '#0076CD',
  bzOrangeDark: '#D78E31',
  bzOrangeDarker: '#a56300',

  bzGrayDarkTone10: '#283d59',
  bzGrayDarkTone20: '#b8cbe5',
  bzGreen100: '#30bf60',
  bzRed100: '#ff4050',
};

const font = {
  inherit: 'inherit',
  initial: 'initial',
  mono: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',

  sans: 'Manrope", "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
  serif: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
};

const fontWeight = {
  bold: '700',
  extrabold: '800',
  inherit: 'inherit',
  initial: 'initial',
  light: '300',
  medium: '500',

  normal: '400',
  semibold: '600',
};

const lineHeight = {
  '10': '40px',
  '3': '12px',
  '4': '16px',
  '5': '20px',
  '6': '24px',
  '7': '28px',
  '8': '32px',
  '9': '36px',
  inherit: 'inherit',
  initial: 'initial',
  loose: '2',
  none: '1',
  normal: '1.5',
  relaxed: '1.625',

  snug: '1.375',
  tight: '1.25',
};

const letterSpacing = {
  inherit: 'inherit',
  initial: 'initial',
  normal: '0em',
  tight: '-0.025em',
  tighter: '-0.05em',
  wide: '0.025em',

  wider: '0.05em',
  widest: '0.1em',
};

const borderWidth = {
  '0': '0',
  '1': '1px',
  '2': '2px',
  '4': '4px',
  '8': '8px',

  inherit: 'inherit',
  initial: 'initial',
};

const borderStyle = {
  dashed: 'dashed',
  dotted: 'dotted',
  double: 'double',
  inherit: 'inherit',
  initial: 'initial',

  none: 'none',
  solid: 'solid',
};

const borderRadius = {
  '2xl': '16px',
  '3xl': '24px',
  default: '4px',
  full: '9999px',
  inherit: 'inherit',
  initial: 'initial',
  lg: '8px',
  md: '6px',
  none: 'none',

  sm: '2px',
  xl: '12px',
};

const shadow = {
  '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  default: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  inherit: 'inherit',
  initial: 'initial',
  inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',

  none: 'none',
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
};

const zIndex = {
  '0': '0',
  '10': '10',
  '20': '20',
  '30': '30',
  '40': '40',
  '50': '50',
  auto: 'auto',

  inherit: 'inherit',
  initial: 'initial',
};

const opacity = {
  '0': '0',
  '10': '0.1',
  '100': '1',
  '20': '0.2',
  '25': '0.25',
  '30': '0.3',
  '40': '0.4',
  '5': '0.05',
  '50': '0.5',
  '60': '0.6',
  '70': '0.7',
  '75': '0.75',
  '80': '0.8',
  '90': '0.9',
  '95': '0.95',

  inherit: 'inherit',
  initial: 'initial',
};

const textAlign = {
  center: 'center',
  inherit: 'inherit',
  initial: 'initial',
  justify: 'justify',

  left: 'left',
  right: 'right',
};

const flex = {
  '1': '1 1 0%',
  auto: '1 1 auto',
  inherit: 'inherit',
  initial: '0 1 auto',
  none: 'none',
};

const flexGrow = {
  '0': '0',
  '1': '1',

  inherit: 'inherit',
  initial: 'initial',
};

const flexShrink = {
  '0': '0',
  '1': '1',

  inherit: 'inherit',
  initial: 'initial',
};

const flexOrder = {
  '1': '1',
  '10': '10',
  '11': '11',
  '12': '12',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  first: '-9999',
  inherit: 'inherit',
  initial: 'initial',

  last: '9999',
  none: '0',
};

const gridSpan = {
  '1': 'span 1 / span 1',
  '10': 'span 10 / span 10',
  '11': 'span 11 / span 11',
  '12': 'span 12 / span 12',
  '2': 'span 2 / span 2',
  '3': 'span 3 / span 3',
  '4': 'span 4 / span 4',
  '5': 'span 5 / span 5',
  '6': 'span 6 / span 6',
  '7': 'span 7 / span 7',
  '8': 'span 8 / span 8',
  '9': 'span 9 / span 9',
  auto: 'auto',
  full: '1 / -1',
};

const gridStart = {
  '1': '1',
  '10': '10',
  '11': '11',
  '12': '12',
  '13': '13',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  auto: 'auto',
};

const gridEnd = {
  '1': '1',
  '10': '10',
  '11': '11',
  '12': '12',
  '13': '13',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  auto: 'auto',
};

const gridTemplate = {
  '1': 'repeat(1, minmax(0, 1fr))',
  '10': 'repeat(10, minmax(0, 1fr))',
  '11': 'repeat(11, minmax(0, 1fr))',
  '12': 'repeat(12, minmax(0, 1fr))',
  '2': 'repeat(2, minmax(0, 1fr))',
  '3': 'repeat(3, minmax(0, 1fr))',
  '4': 'repeat(4, minmax(0, 1fr))',
  '5': 'repeat(5, minmax(0, 1fr))',
  '6': 'repeat(6, minmax(0, 1fr))',
  '7': 'repeat(7, minmax(0, 1fr))',
  '8': 'repeat(8, minmax(0, 1fr))',
  '9': 'repeat(9, minmax(0, 1fr))',
  none: 'none',
};

const gridAuto = {
  auto: 'auto',
  fr: 'minmax(0, 1fr)',
  max: 'max-content',
  min: 'min-content',
};

const gridAutoFlow = {
  col: 'column',
  colDense: 'column dense',
  row: 'row',
  rowDense: 'row dense',
};

const display = {
  block: 'block',
  contents: 'contents',
  flex: 'flex',
  flowRoot: 'flow-root',
  grid: 'grid',
  inherit: 'inherit',
  initial: 'initial',
  inline: 'inline',
  inlineBlock: 'inline-block',
  inlineFlex: 'inline-flex',
  inlineGrid: 'inline-grid',
  inlineTable: 'inline-table',
  listItem: 'list-item',
  none: 'none',
  table: 'table',
  tableCaption: 'table-caption',
  tableCell: 'table-cell',
  tableColumn: 'table-column',
  tableColumnGroup: 'table-column-group',
  tableFooterGroup: 'table-footer-group',
  tableHeaderGroup: 'table-header-group',

  tableRow: 'table-row',
  tableRowGroup: 'table-row-group',
};

const float = {
  inherit: 'inherit',
  initial: 'initial',
  left: 'left',

  none: 'none',
  right: 'right',
};

const boxSizing = {
  borderBox: 'border-box',
  contentBox: 'content-box',

  inherit: 'inherit',
  initial: 'initial',
};

const overflow = {
  auto: 'auto',
  hidden: 'hidden',
  inherit: 'inherit',
  initial: 'initial',

  scroll: 'scroll',
  visible: 'visible',
};

const position = {
  absolute: 'absolute',
  fixed: 'fixed',
  inherit: 'inherit',
  initial: 'initial',
  relative: 'relative',

  static: 'static',
  sticky: 'sticky',
};

const visibility = {
  hidden: 'hidden',
  inherit: 'inherit',

  initial: 'initial',
  visible: 'visible',
};

const flexDirection = {
  column: 'column',
  columnReverse: 'column-reverse',
  inherit: 'inherit',
  initial: 'initial',

  row: 'row',
  rowReverse: 'row-reverse',
};

const flexWrap = {
  inherit: 'inherit',
  initial: 'initial',
  nowrap: 'nowrap',

  wrap: 'wrap',
  wrapReverse: 'wrap-reverse',
};

const justifyContent = {
  center: 'center',
  flexEnd: 'flex-end',
  flexStart: 'flex-start',
  inherit: 'inherit',
  initial: 'initial',
  spaceAround: 'space-around',

  spaceBetween: 'space-between',
  spaceEvenly: 'space-evenly',
};

const justifyItems = {
  center: 'center',
  end: 'end',
  inherit: 'inherit',
  initial: 'initial',

  start: 'start',
  stretch: 'stretch',
};

const justifySelf = {
  auto: 'auto',
  center: 'center',
  end: 'end',
  inherit: 'inherit',
  initial: 'initial',

  start: 'start',
  stretch: 'stretch',
};

const alignContent = {
  center: 'center',
  flexEnd: 'flex-end',
  flexStart: 'flex-start',
  inherit: 'inherit',
  initial: 'initial',
  spaceAround: 'space-around',

  spaceBetween: 'space-between',
  spaceEvenly: 'space-evenly',
};

const alignItems = {
  baseline: 'baseline',
  center: 'center',
  flexEnd: 'flex-end',
  flexStart: 'flex-start',
  inherit: 'inherit',

  initial: 'initial',
  stretch: 'stretch',
};

const alignSelf = {
  auto: 'auto',
  center: 'center',
  flexEnd: 'flex-end',
  flexStart: 'flex-start',
  inherit: 'inherit',

  initial: 'initial',
  stretch: 'stretch',
};

const placeContent = {
  center: 'center',
  end: 'end',
  inherit: 'inherit',
  initial: 'initial',
  spaceAround: 'space-around',
  spaceBetween: 'space-between',
  spaceEvenly: 'space-evenly',

  start: 'start',
  stretch: 'stretch',
};

const placeItems = {
  center: 'center',
  end: 'end',
  inherit: 'inherit',
  initial: 'initial',

  start: 'start',
  stretch: 'stretch',
};

const placeSelf = {
  auto: 'auto',
  center: 'center',
  end: 'end',
  inherit: 'inherit',
  initial: 'initial',

  start: 'start',
  stretch: 'stretch',
};

const listStyle = {
  decimal: 'decimal',
  disc: 'disc',
  inherit: 'inherit',

  initial: 'initial',
  none: 'none',
};

const listStylePosition = {
  inherit: 'inherit',
  initial: 'initial',

  inside: 'inside',
  outside: 'outside',
};

const textDecoration = {
  inherit: 'inherit',
  initial: 'initial',
  lineThrough: 'line-through',

  none: 'none',
  underline: 'underline',
};

const textOverflow = {
  clip: 'clip',
  ellipsis: 'ellipsis',

  inherit: 'inherit',
  initial: 'initial',
};

const verticalAlign = {
  baseline: 'baseline',
  bottom: 'bottom',
  inherit: 'inherit',
  initial: 'initial',
  middle: 'middle',
  textBottom: 'text-bottom',

  textTop: 'text-top',
  top: 'top',
};

const whiteSpace = {
  inherit: 'inherit',
  initial: 'initial',
  normal: 'normal',
  nowrap: 'nowrap',
  pre: 'pre',
  preLine: 'pre-line',

  preWrap: 'pre-wrap',
  textTop: 'text-top',
};

const backgroundPosition = {
  bottom: 'bottom',
  center: 'center',
  inherit: 'inherit',
  initial: 'initial',
  left: 'left',
  leftBottom: 'left bottom',
  leftTop: 'left top',
  right: 'right',
  rightBottom: 'right bottom',

  rightTop: 'right top',
  top: 'top',
};

const backgroundSize = {
  auto: 'auto',
  contain: 'contain',
  cover: 'cover',

  inherit: 'inherit',
  initial: 'initial',
};

const backgroundRepeat = {
  inherit: 'inherit',
  initial: 'initial',
  noRepeat: 'no-repeat',
  repeat: 'repeat',
  repeatX: 'repeat-x',
  repeatY: 'repeat-y',

  round: 'round',
  space: 'space',
};

const backgroundAttachment = {
  fixed: 'fixed',
  inherit: 'inherit',
  initial: 'initial',

  local: 'local',
  scroll: 'scroll',
};

const backgroundClip = {
  borderBox: 'border-box',
  contentBox: 'content-box',
  inherit: 'inherit',
  initial: 'initial',

  paddingBox: 'padding-box',
  text: 'text',
};

const blendMode = {
  color: 'color',
  colorBurn: 'color-burn',
  colorDodge: 'color-dodge',
  darken: 'darken',
  difference: 'difference',
  exclusion: 'exclusion',
  hardLight: 'hard-light',
  hue: 'hue',
  lighten: 'lighten',
  luminosity: 'luminosity',
  multiply: 'multiply',
  normal: 'normal',
  overlay: 'overlay',
  saturation: 'saturation',
  screen: 'screen',
  softLight: 'soft-light',
};

const tableLayout = {
  auto: 'auto',
  fixed: 'fixed',
};

const cursor = {
  auto: 'auto',
  default: 'default',
  help: 'help',
  inherit: 'inherit',
  initial: 'initial',
  move: 'move',
  notAllowed: 'not-allowed',
  pointer: 'pointer',

  text: 'text',
  wait: 'wait',
};

const pointerEvents = {
  auto: 'auto',
  inherit: 'inherit',

  initial: 'initial',
  none: 'none',
};

const resize = {
  both: 'both',
  inherit: 'inherit',
  initial: 'initial',
  none: 'none',

  x: 'horizontal',
  y: 'vertical',
};

const userSelect = {
  all: 'all',
  auto: 'auto',
  inherit: 'inherit',
  initial: 'initial',

  none: 'none',
  text: 'text',
};

const strokeWidth = {
  '0': '0',
  '1': '1',
  '2': '2',

  inherit: 'inherit',
  initial: 'initial',
};

const booleanProps = {
  /**
   * Makes text font smooth antialiased.
   */
  antialiased: {
    '-moz-osx-font-smoothing': 'grayscale',
    '-webkit-font-smoothing': 'antialiased',
  },

  /**
   * Makes table borders collapse.
   */
  borderCollapse: {
    borderCollapse: 'collapse',
  },

  /**
   * Makes table borders separate.
   */
  borderSeparate: {
    borderCollapse: 'separate',
  },

  breakAll: {
    'word-break': 'break-all',
  },

  breakNormal: {
    'overflow-wrap': 'normal',
    'word-break': 'normal',
  },

  breakWords: {
    'overflow-wrap': 'break-word',
  },

  /**
   * Capitalizes text. Ex: foo -> Foo
   */
  capitalize: {
    'text-transform': 'capitalize',
  },

  /**
   * Uses container limits based on screen breakpoint tokens.
   */
  container: Object.values(screen).reduce(
    (memo, val) => ({
      ...memo,
      [`@media (min-width: ${val})`]: {
        maxWidth: val,
      },
    }),
    {},
  ),

  invisible: {
    visibility: 'hidden',
  },

  /**
   * Makes text italic.
   */
  italic: {
    'font-style': 'italic',
  },

  /**
   * Makes text lowercase. Ex: Foo -> foo | FOO -> foo
   */
  lowercase: {
    'text-transform': 'lowercase',
  },

  /**
   * Sets appearance as none.
   */
  noAppearance: {
    appearance: 'none',
  },

  /**
   * Sets outline as none.
   */
  noOutline: {
    outline: 'none',
  },

  /**
   * Makes text normal case.
   */
  normalCase: {
    'text-transform': 'none',
  },

  /**
   * Use notSrOnly to undo sr-only, making an element visible to sighted users as well as screen readers. This can be useful when you want to visually hide something on small screens but show it on larger screens.
   */
  notSrOnly: {
    clip: 'auto',
    height: 'auto',
    margin: 0,
    overflow: 'visible',
    padding: 0,
    position: 'static',
    'white-space': 'normal',
    width: 'auto',
  },

  /**
   * Use srOnly to hide an element visually without hiding it from screen readers.
   */
  srOnly: {
    'border-width': 0,
    clip: 'rect(0, 0, 0, 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    'white-space': 'nowrap',
    width: '1px',
  },

  /**
   * Makes text font smooth subpixel antialiased.
   */
  subpixelAntialiased: {
    '-moz-osx-font-smoothing': 'auto',
    '-webkit-font-smoothing': 'auto',
  },

  /**
   * Truncates text adding elipsis. Ex: My long text -> My long...
   */
  truncate: {
    overflow: 'hidden',
    'text-overflow': 'ellipsis',
    'white-space': 'nowrap',
  },

  /**
   * Makes text lowercase. Ex: Foo -> FOO | foo -> FOO
   */
  uppercase: {
    'text-transform': 'uppercase',
  },

  visible: {
    visibility: 'visible',
  },
};

type MediaQueries = Record<keyof typeof screen, string>;

const mediaQueries: MediaQueries = Object.entries(screen).reduce(
  (memo, [key, val]) => ({
    ...memo,
    [key]: `@media (min-width: ${val})`,
  }),
  {} as MediaQueries,
);

export const designTokens = {
  alignContent,
  alignItems,
  alignSelf,
  backgroundAttachment,
  backgroundClip,
  backgroundPosition,
  backgroundRepeat,
  backgroundSize,
  blendMode,
  booleanProps,
  borderRadius,
  borderStyle,
  borderWidth,
  boxSizing,
  colorPalette,
  cursor,
  display,
  flex,
  flexDirection,
  flexGrow,
  flexOrder,
  flexShrink,
  flexWrap,
  float,
  font,
  fontSize,
  fontWeight,
  gridAuto,
  gridAutoFlow,
  gridEnd,
  gridSpan,
  gridStart,
  gridTemplate,
  justifyContent,
  justifyItems,
  justifySelf,
  letterSpacing,
  lineHeight,
  listStyle,
  listStylePosition,
  mediaQueries,
  opacity,
  overflow,
  placeContent,
  placeItems,
  placeSelf,
  pointerEvents,
  position,
  resize,
  screen,
  shadow,
  space,
  spaceWithAuto,
  spaceWithNone,
  strokeWidth,
  tableLayout,
  textAlign,
  textDecoration,
  textOverflow,
  userSelect,
  verticalAlign,
  visibility,
  whiteSpace,
  zIndex,
};
